import { RedirectRoute } from '../Routing/types';

const redirects: RedirectRoute[] = [
  {
    path: '/goal-settings',
    redirectTo: '/goal-settings/weight',
  },
  {
    path: '/goalSettings',
    redirectTo: '/goal-settings/weight',
  },
];

export default redirects;
